import React, { useState, useEffect, useRef, useContext } from 'react'
import queryString from 'query-string'
import Axios from 'axios'
import moment from 'moment'
import { TextEditor, getContent, isContentChanged, resetIsContentChanged, isUndoEmpty, isRedoEmpty, handleRedo as onRedo, handleUndo as onUndo} from '../../../../components/TextEditor'
import { get, post, put } from '../../../../lib/api'
import SaveIcon from '../../../../components/Images/Save'
import CircleCheck from '../../../../components/Images/CircleCheck'
import { Revisions } from '../../../../components/TextEditor/revisions'
import Loader from '../../../../components/Loader'
import GenericError from '../../../../components/GenericError'
import AlertSnackBar from '../../../../components/AlertSnackBar'
import PrivatePage, { menuItemObj } from '../../../../components/PrivatePage'
import { Provider } from '../../../../context/editorContext'
import { EditorControls } from '../../Audiobooks/Unpublished/Edit/chapterEditor'
import {handleEventLog, handlePageLoadEventLog, removeSpecialCharacters} from '../../../../lib/utils'
import { novelChapterWordCount } from '../../../../constants';
import './chapterAddEdit.css';
import {getPlainContent} from "../../../../components/TextEditor/TinyMCEEditor";
import ChapterScheduler from '../ChapterScheduler'
import { get as getFromLocal, set as setToLocal } from '../../../../lib/storage/index'
import PostPublishScreen from './PostPublishScreen'
import VerifyForBadPublish from './PopupsInChapterAddEdit/VerifyForBadPublish'
import HasUnsavedChanges from './PopupsInChapterAddEdit/HasUnsavedChanges'
import CalendarPopup from './PopupsInChapterAddEdit/CalendarPopup'
import SchedulePublishPopup from './PopupsInChapterAddEdit/SchedulePublishPopup'
import RestrictDelete from './PopupsInChapterAddEdit/RestrictDelete'
import WarningPopup from './PopupsInChapterAddEdit/WarningPopup'
import DeclarationPopup from './PopupsInChapterAddEdit/DeclarationPopUp'
import { AccountContext } from '../../../../providers/accountProvider'

export default function ChapterAddEdit(props) {
  const {
    history,
    match: {
      params: { id, action },
    },
    location: { search },
  } = props
  const qParams = queryString.parse(search)
  const { proceed_to_details, redirect_to_home, redirect_to_novel } = qParams

  const [chapter_id, setChapter_id] = useState(
    queryString.parse(search).chapter_id
  )
  const chapterCount = queryString.parse(search).count || 0
  const { tab } = queryString.parse(search);
  // const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  // const currentDate=`${new Date().getDay()}-${months[new Date().getMonth()]}-${new Date().getFullYear()}`
  const [content, setContent] = useState('')
  const [wordCount, setWordCount] = useState(0)
  const [editorState, setEditorState] = useState(null)
  const [title, setTitle] = useState('Untitled Chapter')
  const [showVersion, toggleShowVersion] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [popUpLoader, setPopUpLoader] = useState(false)
  const [chapterDetails, setChapterDetails] = useState()
  const [apiError, toggleApiError] = useState(false)
  const [titleChanged, setTitleChanged] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [savedChanges, setSavedChanges] = useState(false)
  const [warningPopup, setWarningPopup] = useState(false);
  const [schedulePublishPopup, setSchedulePublishPopup] = useState(false);
  const [calendarPopup, setCalendarPopup] = useState(false);
  const [declarationPopUp, setDeclarationPopup] = useState(false)
  const [isBack,setIsBack] = useState(false)
  const [alertText, setAlertText] = useState('')
  const [userCalendarDate,setUserCalendarDate]=useState('');
  const [timer,toggleTimer]=useState(true);
  const [hasPublishWarning,setHasPublishWarning]=useState(false);
  const [novelDetails, updateNovelDetails] = useState({});
  const [restrictDelete, setRestrictDelete] = useState(false)
  const [schedulerPopup, toggleSchedulerPopup] = useState(false)
  const [showPostPublishScreen, togglePostPublishScreen] = useState(false)
  const [showPostPublishData, setPostPublishData] = useState(null)
  const [audioSelction, updateAudioSelection] = useState(null)
  const [isEligibleForIncentive, updateIncentiveEligibility] = useState(false)
  const [cdCheckbox, updateCdCheckbox] = useState({
    copyright_declaration: false,
    sexual_content_declaration: false,
    non_consensual_sex_declaration: false
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [fileURL, setFileURL] = useState(null)
  const [verifyForBadPublish, setVerifyForBadPublish] = useState({ show : false});
  const isMounted = useRef(false)
  const { isUgcUser } = useContext(AccountContext)
  const pushToNovelForm = isUgcUser && novelDetails?.is_novel === 2 && (wordCount + novelDetails?.word_count >= 10000) && !novelDetails?.trope_info?.length && !novelDetails?.maturity_rating
  const fetchNovelDetails = () => {
    const params = {
      uid: localStorage.getItem('uid'),
      book_id: props.match.params.id,
      req_author: 1,
      view: 'writers',
      is_novel: 1
    }
    get('/content_api/book.novel_details', { params: params })
      .then((response) => {
        response = response.results;
        updateNovelDetails(response);
        if(response.declaration === "True"){
          updateCdCheckbox({
            copyright_declaration: true,
            sexual_content_declaration: true,
            non_consensual_sex_declaration: true
          })
        }
        if(!chapter_id && response?.is_novel === 2){
          setTitle('Chapter Title')
        }
    });
    get(`/content_api/book.creator_ben_prog/?book_id=${props.match.params.id}&is_novel=1`)
      .then((response) => {
        updateIncentiveEligibility(Boolean(response?.books?.[0]?.eligible_for_incentive))
    });
  }

  useEffect(() => {
    handlePageLoadEventLog('edit_chapter');
    fetchNovelDetails();

    return () => {
      isMounted.current = true
    }
  },[])

  const getChapterObject = () => chapter_id ? JSON.parse(getFromLocal('autosave'))?.[chapter_id] : null

  useEffect(() => {
    if(isContentChanged(editorState)){
      if(chapter_id){
        const content = getContent(editorState)
        const chapterObject  = getChapterObject()
        if(chapterObject && chapterObject.fileURL === fileURL) setChapterObject({chapterId:chapter_id, fileURL, content})
        else setChapterObject({chapterId:chapter_id, fileURL, content})
      } 
    }
    return () => {
    };
  })
  const handlePublishChapterWithVoice = (chapterId, url, isNewVersion) => {
    if(!novelDetails?.show_id){
      console.log("no show id")
      return
    }
    const convertAudioData = {
      'show_id': novelDetails?.show_id,
      'chapter_id': chapterId,
      'script_url': url,
      "regeneration_required": isNewVersion ? true : false
    }
    if(novelDetails.stats.published_chapter_count === 0){
      const { voice_selection, background_music } = audioSelction
      const voiceData = {
        'voice_id' : voice_selection?.voice_id,
        "show_id": novelDetails?.show_id,
        "mastering_genre": background_music?.key,
        "mastering_required": true,
        "vendor": "eleven_labs",
        "voice_name": voice_selection?.name
      }
      post(`/content_api/ugc/audio/configure_ugc_show/`,{data : voiceData})
        .then((res) => {
            console.log("configure ugc show",res)
            post(`/content_api/ugc/audio/convert_to_audio/`, { data : convertAudioData})
            .then((result) => { console.log("converted Audio Result ", result) })
        })
    }else{
      post(`/content_api/ugc/audio/convert_to_audio/`, { data : convertAudioData})
        .then((result) => { console.log("converted Audio Result ", result) })
    }
    
   
   
  }

  const handlePublishLog = (startTime,chapterId) => {
    const now = new Date()
    const endTime = now.getTime()
    const timeDiff = (endTime-startTime)/1000
    handleEventLog('edit_chapter','publish_request_duration',{time:timeDiff,route : window.location.pathname + window.location.search,entity_type: 'chapter',entity_id: chapterId})
  }
 
  const setChapterObject = (chapterObj) => {
     const chaptersObject = JSON.parse(getFromLocal('autosave')) ?? {}
     chaptersObject[chapterObj.chapterId] = chapterObj
     setToLocal('autosave',JSON.stringify(chaptersObject))
   }
  
  const checkUnsavedChanges = (fileURL,content) => {
    if(chapter_id){
      const chapterObject = getChapterObject();
      if(chapterObject && chapterObject.content && chapterObject.content !== content && chapterObject.fileURL === fileURL){
        setHasUnsavedChanges(true);
      } 
      else setChapterObject({chapterId:chapter_id,fileURL,content})
    }
  }

  const fetchChapterDetails = () => {
    setLoading(true)
    get('/content_api/book.get_chapter_details', {
      params: {
        chapter_id,
        book_id: id,
        view: 'writers',
        is_novel: 1
      },
    })
      .then((response) => {
        setChapterDetails(response)
        const { result } = response
        const { file_url, chapter_title, status } = result
        setFileURL(file_url)
        Axios.get(file_url)
          .then((response) => {
            setTitle(chapter_title)
            setContent(response.data)
            checkUnsavedChanges(file_url,response.data);
          })
          .catch((err) => {
            props.history.goBack()
            setIsBack(true)
            throw err
          })
      })
      .catch((err) => {
        props.history.goBack()
        setIsBack(true)
        throw err
      })
  }

  useEffect(() => {
    if (!chapter_id) return
    fetchChapterDetails()
  }, [])

  useEffect(() => {
    if (title && content) setLoading(false)
  }, [title, content])
  
  const updateState = (editor) => {
    setEditorState(editor)
  }

  const repeatedWordsCount = () => {
    let getContentText = getPlainContent()
    getContentText = removeSpecialCharacters(getContentText);
    if(getContentText.length < 1) return 0
    const words = getContentText.split(" ");
    const wordMap = {};
    let totalRepeatedWords=0;
    for (let i = 0; i < words.length; i+=1) {
      const currentWordCount = wordMap[words[i]];
      const count = currentWordCount ? currentWordCount : 0;
      wordMap[words[i]] = count + 1;
    }
    for(const val in wordMap){
      if(wordMap[val] > 1){
        totalRepeatedWords += wordMap[val] - 1
      }
    }
    return totalRepeatedWords
  }

  const handleBackForPostPublishScreen = () => {
    props.history.goBack()
    setIsBack(true)
  }
  
  const checkIfWordCountIsZero = () => {
    if(!wordCount){
      Promise.reject({message: 'Word Count cannot be 0'})
      return true
    }
  }

  const handleVerificationPopup = async (resp) => {   // this function allows to wait for the user's response in popup
    return new Promise((resolve, reject)=> {          
      setVerifyForBadPublish({
        show : true , 
        loading : false, 
        issue_type : resp?.issue,
        publish_anyway : resolve,
        review_again : resolve,
        words: resp?.problematic_words || [],
        message: resp?.message
      })
    })
  }

  const waitForSomeTime = async (time) => {
    return new Promise((resolve, reject) => {
      setTimeout(()=> {
        resolve('resolved')
      }, time)
    })
  }

  const VerifyChapter = async (details, status, url, latestVersion) => {
    if ((novelDetails?.verification_required === "True" || details?.seq_number == 1) && status === 'review' && details?.status !== 'published') {                // if verification_required is true for the book
      setVerifyForBadPublish({show : true , loading : true})  // open the popup to wait for verification and start loading
      try {
        let result = {message : 'Pending'}
        let maxApiCalls = 1
        while ((result?.message === 'Pending' || !result?.verified) && !isMounted.current && maxApiCalls < 11) {
          const resp = await post('/content_api/book.chapters/verify_chapter/?is_novel=1', {      // calling the verification for bad content api
            data : {
              uid: localStorage.getItem('uid'),
              book_id: id,
              chapter_id: details.chapter_id,
              latest_version: latestVersion || details.latest_version,
              file_url: url || details?.file_url || fileURL,
              version_id: details.version_id,
              counter: maxApiCalls
            }
          })
          if (resp?.message !== 'Pending' && !resp?.verified){ 
            setVerifyForBadPublish({show : false , loading : false})
            return true
          }
          result = {...resp}
          await waitForSomeTime(1000)          // This function is to give time between api calls
          maxApiCalls+=1
        }
        if (result.verified && !result.issue_found) {
          setVerifyForBadPublish({show : false , loading : false})
          return true
        }
        else if (result.verified && result.issue_found) {                                  // if some issues are found
          const userPopupResponse = await handleVerificationPopup(result)  
          if (userPopupResponse === 'review_again') {               // if response is review_again then only stop the flow
            toggleSchedulerPopup(false)
            return false 
          } else {                                // else publish it by just changing the status
            const now = new Date()
            const startTime = now.getTime();
            const chapterData={
              chapter_id: details.chapter_id,
              status: 'published',
              book_id: id,
              view: 'writers',
              program_type: novelDetails?.program_type || null
            }
            if(userCalendarDate)
                chapterData.schedule_time=moment(`${userCalendarDate} 06:00 AM`).format('YYYY-MM-DD HH:mm:ss');
            
            put('/content_api/book.update_chapter_status?is_novel=1', {
              data: chapterData,
            })
              .then(() => {
                setAlertText('Published Successfully')
                setSavedChanges(true)
                handlePublishLog(startTime,details.chapter_id)
                setUserCalendarDate(userCalendarDate)
                if(redirect_to_novel){
                  history.push(`${menuItemObj.novels}/id/${id}`)
                  return
                }else if (proceed_to_details) {
                  history.push(`${menuItemObj.novels}/edit-novel-details/${id}?publish_chapter_id=${details.chapter_id}&redirect_to_home=${redirect_to_home ? '1' : ''}&first_publish=1`)
                  return
                }else if(pushToNovelForm){
                  history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
                  return
                }
                props.history.goBack()
              })
          }
        }
        else if (maxApiCalls === 11){
          return true
        }
      } catch (error) {
        setVerifyForBadPublish({show : false , loading : false})
        console.log(error)
        return true  // even if the api fails for some reason we don't have to stop publishing chapter
      }
    }
    return true;
  }

  const createChapterOrVersion = async (status, url,userCalendarDate) => {
    if(checkIfWordCountIsZero()) return
    const repeated_words_count = repeatedWordsCount()
    if (chapter_id) {        // if we are dealing with already created chapter
      if (titleChanged) {
        const dataForVersion = {
          book_id: id,
          chapter_id,
          word_count: wordCount,
          repeated_words_count,
          file_url: url,
          chapter_title: title,
          status: status,
          view: 'writers',
          program_type: novelDetails?.program_type || null
        }
        if(userCalendarDate)
          dataForVersion.schedule_time=moment(`${userCalendarDate} 06:00 AM`).format('YYYY-MM-DD HH:mm:ss');
        try {
          await post('/content_api/book.create_chapter?is_novel=1', {
            data: dataForVersion,
          })
        } catch (err) {
          if(novelDetails.content_editing && err.code === 400){
            setRestrictDelete(true)
          }else throw err
        }
      }
      const dataForChapterVersion = {
        chapter_id,
        word_count: wordCount,
        repeated_words_count,
        file_url: url,
        chapter_title: title,
        book_id: id,
        view: 'writers',
        status: status,
      }
      
      if(userCalendarDate)
        dataForChapterVersion.schedule_time=moment(`${userCalendarDate} 06:00 AM`).format('YYYY-MM-DD HH:mm:ss');
      post('/content_api/book.version?is_novel=1', {
        data: dataForChapterVersion,
      }).then(async (res)=> {
        setIsSubmitting(false)
        const isChapterSafe = await VerifyChapter(chapterDetails.result, status, url, res.latest_version)
        if (!isChapterSafe) return
        if(status !== 'draft'){
          handlePublishChapterWithVoice(chapter_id, url, true)
        }
        setAlertText('Updated Successfully')
        const now = new Date();
        const startTime = now.getTime()
        setSavedChanges(true)
        setIsBack(true)
        if (proceed_to_details) {
          history.push(`${menuItemObj.novels}/edit-novel-details/${id}?publish_chapter_id=${chapter_id}&redirect_to_home=${redirect_to_home ? '1' : ''}`)
        }else if(status !== 'draft') {
          handlePublishLog(startTime,chapter_id)
          if(pushToNovelForm){
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
            return
          }else{
            props.history.goBack()
          }
        }
      }).catch((err)=> {
        setIsSubmitting(false)
        if(novelDetails.content_editing && err.code === 400){
          setRestrictDelete(true)
        }else throw err
      })
    } else { // if we save or publish a new chapter
      const now = new Date()
      const startTime = now.getTime()
      const dataForChapter = {
        book_id: id,
        chapter_title: title,
        file_url: url,
        word_count: wordCount,
        repeated_words_count,
        status: status,
        view: 'writers',
        program_type: novelDetails?.program_type || null
      }
      setSavedChanges(true)
      if(userCalendarDate)
        dataForChapter.schedule_time=moment(`${userCalendarDate} 06:00 AM`).format('YYYY-MM-DD HH:mm:ss');
      try {
        const res = await post('/content_api/book.create_chapter?is_novel=1', {
          data: dataForChapter,
        })
        setDeclarationPopup(false)
        setChapter_id(res.results.chapter_id)
        const isChapterSafe = await VerifyChapter(res?.results, status, url)
        if (!isChapterSafe) {
          setIsSubmitting(false)
          resetIsContentChanged(false)
          history.replace(`${menuItemObj.novels}/edit-chapter/${id}?chapter_id=${res.results.chapter_id}`)
          return
        }
        if (proceed_to_details) {
          history.push(`${menuItemObj.novels}/edit-novel-details/${id}?publish_chapter_id=${res.results.chapter_id}&redirect_to_home=${redirect_to_home ? '1' : ''}&first_publish=1`)
          return
        }
        if (status !== 'draft') {
          handlePublishChapterWithVoice(res.results.chapter_id, url, false)   
          setAlertText('Published Successfully')
          if(redirect_to_novel){
            history.push(`${menuItemObj.novels}/id/${id}`)
          }
          else if (proceed_to_details) {
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}?publish_chapter_id=${res.results.chapter_id}&redirect_to_home=${redirect_to_home ? '1' : ''}&first_publish=1`)
            return
          } else if(pushToNovelForm){
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
          }
          else {
            handlePublishLog(startTime,res.results.chapter_id)
            setUserCalendarDate(userCalendarDate)
            if(novelDetails?.application_status === 'ongoing' && isEligibleForIncentive){
              setPostPublishData({
                from_incentive_value: res.results?.from_incentive_value || 0,
                to_incentive_value: res.results?.to_incentive_value || 0,
                rem_streak_days: res.results?.rem_streak_days || 0,
                chapter_id: res.results?.chapter_id || "",
                streak_incentive_awareness_variant: res.results?.streak_incentive_awareness_variant || 'A',
                isUgcBook: novelDetails?.is_novel === 2
              })
              togglePostPublishScreen(true)
            }else{
              props.history.goBack()
              setIsBack(true)
            }
          }
        } else {
          resetIsContentChanged(false)
          get('/content_api/book.get_chapter_details', {
            params: {
              chapter_id: res.results.chapter_id,
              book_id: id,
              view: 'writers',
              is_novel: 1
            },
          }).then((response) => {
            // setAlertText('Saved Successfully')
            setChapterDetails(response)
            setSavedChanges(true)
            setIsSubmitting(false)
            setIsBack(true)
          })
          setIsSubmitting(false)
        }
      } catch (error) {
        setIsSubmitting(false)
          if(novelDetails.content_editing && error.code === 400){
            setRestrictDelete(true)
          }else throw error
      }
    }
  }

  // when clicked on save above editor
  const handleVersionSave = () => {
    if(checkIfWordCountIsZero()) return
    const repeated_words_count = repeatedWordsCount()

    // if only content or both content and title changed
    // and chapter can be published or draft
    if (
      isContentChanged(editorState) &&
      title.length > 0 &&
      wordCount > 0 &&
      !isSubmitting 
    ) {
      setIsSubmitting(true)
      uploadFile('draft')

    } else if (chapter_id && titleChanged && title.length > 0) {  
      // if only title is changed, not content
      post('/content_api/book.create_chapter?is_novel=1', {
        data: {
          book_id: id,
          chapter_id,
          word_count: wordCount,
          repeated_words_count,
          file_url: chapterDetails.result.file_url,
          chapter_title: title,
          status: chapterDetails.result.status,
          content_unchanged: 1,
          view: 'writers',
          program_type: novelDetails?.program_type || null
        },
      })
        .then(() => {
          setAlertText('Saved Successfully')
          setTitleChanged(false)
          setIsSubmitting(false)
          setSavedChanges(true)
        })
        .catch((err) => {
          setIsSubmitting(false)
          throw err
        })
    } else if (title.length > 0 && wordCount > 0) {
      setSavedChanges(true)
    } else {
      return
    }
  }

  // called when click on publish
  const handleVersionPublish = async (userCalendarDate, popUpLoad=0) => {
    if(checkIfWordCountIsZero()) return
    if(wordCount > 5000){
      setHasPublishWarning(true)
      setAlertText('Please write below 5000 words and then publish the chapter')
      return
    }
    if(proceed_to_details !==1 && wordCount >= novelChapterWordCount && (!cdCheckbox.copyright_declaration || !cdCheckbox.non_consensual_sex_declaration || !cdCheckbox.sexual_content_declaration)){
      updateCdCheckbox({
        copyright_declaration: true,
        sexual_content_declaration: true,
        non_consensual_sex_declaration: true
      })
      setDeclarationPopup(novelDetails?.is_novel === 2 ? false : true);
      handleEventLog("edit-chapter","page-load",{
        module_name:"content_declaration"
      })
      return;
    }
    const repeated_words_count = repeatedWordsCount()
    if(!popUpLoad) setDeclarationPopup(false);

    let moveToStatus = 'published'
    if (proceed_to_details) moveToStatus = 'draft'
    else if (novelDetails?.is_novel === 1 && novelDetails.verification_required === "True") moveToStatus = 'review'
    
    // if content is changed
    if (
      isContentChanged(editorState) &&
      wordCount >= novelChapterWordCount &&
      !isSubmitting
    ) {
      setIsSubmitting(true)
      uploadFile(moveToStatus, userCalendarDate)

    } else if (
      chapter_id &&
      chapterDetails.result.status === 'draft' &&
      !isContentChanged(editorState) &&
      wordCount >= novelChapterWordCount &&
      !titleChanged
    ) {
      // only chapter status is changing from draft, not the content or title
      const now = new Date()
      const startTime = now.getTime();
      const chapterData={
        chapter_id,
        status: moveToStatus,
        book_id: id,
        view: 'writers',
      }
      if(userCalendarDate)
          chapterData.schedule_time=moment(`${userCalendarDate} 06:00 AM`).format('YYYY-MM-DD HH:mm:ss');
      
      put('/content_api/book.update_chapter_status?is_novel=1', {
        data: chapterData,
      })
        .then(async (res) => {
          const isChapterSafe = await VerifyChapter(chapterDetails.result, moveToStatus)
          setIsSubmitting(false)
          if (!isChapterSafe) return
          handlePublishChapterWithVoice(chapter_id, chapterDetails.result?.file_url, true)
          if(redirect_to_novel){
            history.push(`${menuItemObj.novels}/id/${id}`)
            return
          }
          else if (proceed_to_details) {
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}?publish_chapter_id=${chapter_id}&redirect_to_home=${redirect_to_home ? '1' : ''}&first_publish=1`)
            return
          }
          setAlertText('Published Successfully')
          setSavedChanges(true)
          handlePublishLog(startTime,chapter_id)
          setUserCalendarDate(userCalendarDate)
          if(novelDetails?.application_status === 'ongoing' && isEligibleForIncentive){
            setPostPublishData({
              from_incentive_value: res?.results?.from_incentive_value || 0,
              to_incentive_value: res?.results?.to_incentive_value || 0,
              rem_streak_days: res?.results?.rem_streak_days || 0,
              chapter_id: res.results?.chapter_id || "",
              streak_incentive_awareness_variant: res.results?.streak_incentive_awareness_variant || 'A',
              isUgcBook: novelDetails?.is_novel === 2
            })
            togglePostPublishScreen(true)
          }else{
            props.history.goBack()
            setIsBack(true)
          }
        })
        .catch((err) => {
          setIsSubmitting(false)
          throw err
        })
    } else if (
      chapter_id &&
      chapterDetails.result.status === 'draft' &&
      !isContentChanged(editorState) &&
      wordCount >= novelChapterWordCount &&
      titleChanged  
    ) {
      // when title is changed of a draft chapter and publishing it
      const now = new Date()
      const startTime = now.getTime();
      const chapterData={
          book_id: id,
          chapter_id,
          word_count: wordCount,
          repeated_words_count,
          file_url: chapterDetails.result.file_url,
          chapter_title: title,
          status: proceed_to_details ? 'draft' : moveToStatus,
          view: 'writers',
          program_type: novelDetails?.program_type || null
      }
      if(userCalendarDate)
        chapterData.schedule_time=moment(`${userCalendarDate} 06:00 AM`).format('YYYY-MM-DD HH:mm:ss');
      post('/content_api/book.create_chapter?is_novel=1', {
        data:chapterData
      })
        .then(async (res) => {
          const isChapterSafe = await VerifyChapter(res?.results, chapterData.status)
          if (!isChapterSafe) {
            setIsSubmitting(false)
            resetIsContentChanged(false)
            return
          }
          handlePublishChapterWithVoice(chapter_id, chapterDetails.result?.file_url, true)
          setTitleChanged(false)
          if (proceed_to_details) {
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}?publish_chapter_id=${chapter_id}&redirect_to_home=${redirect_to_home ? '1' : ''}`)
            return
          }else if(pushToNovelForm){
            history.push(`${menuItemObj.novels}/edit-novel-details/${id}`)
            return
          }
          handlePublishLog(startTime,chapter_id)
          props.history.goBack()
          setIsBack(true)
        })
        .catch((err) => {
          setIsSubmitting(false)
          throw err
        })
    }
  }

  const checkWordCount=()=>{
    if(wordCount < 1000) {
      setHasPublishWarning(true)
      setAlertText("Please complete at least 1000 words to publish a chapter")
      handleEventLog("edit-chapter","Snack_fail_alert",{
        module_name:"Publish",
        entity_type:"chapter"
      })
      return false
    }
    if(wordCount > 5000) {
      setHasPublishWarning(true)
      setAlertText("Please write the chapter below 5000 words & update")
      handleEventLog("edit-chapter","Snack_fail_alert",{
        module_name:"Publish",
        entity_type:"chapter"
      })
      return false
    }
    if(chapterDetails && chapterDetails.result.status === 'published'?title.split('-')[1]?.length<2:title.length === 0){
      setHasPublishWarning(true)
      setAlertText("Please add title")
      handleEventLog("edit-chapter","Snack_fail_alert",{
        module_name:"Publish",
        entity_type:"chapter"
      })
      return false
    }
    return true;
  }

  const handleVersionPublishPopUp = () => {
    if((!cdCheckbox.copyright_declaration || !cdCheckbox.non_consensual_sex_declaration || !cdCheckbox.sexual_content_declaration)){
      setAlertText('Please do the content declaration');
      setHasPublishWarning(true);
      return;
    }
    if(popUpLoader) return;
    setPopUpLoader(true);
    handleEventLog("edit-chapter","button_click",{
      module_name:"content_declaration"
    })
    post(`/content_api/book.create_book?is_novel=${novelDetails?.is_novel || 1}`, {
      data: {
        book_title: novelDetails.book_title,
        language: novelDetails.language,
        book_type: novelDetails.category_obj.book_type,
        category: novelDetails.category,
        copyright_declaration: true,
        sexual_content_declaration: true,
        non_consensual_sex_declaration: true,
        book_id: novelDetails.book_id,
        view: 'writers',
      },
    })
      .then((res) => {
        res=res?.results;
        if(res?.declaration){
          handleVersionPublish(undefined,1);
        }
      }).catch((err) => {
        throw err
      })
  }

  // when updating an already published chapter
  const handleVersionUpdate = () => {
    if(checkWordCount()){
      // if content is changed
      if (isContentChanged(editorState) && wordCount >= novelChapterWordCount && !isSubmitting) {
        setAlertText('Updated Successfully')
        setIsSubmitting(true)
        uploadFile('published')

      } else if (titleChanged && wordCount >= novelChapterWordCount && !isSubmitting) {
        // if only title is changed
        setIsSubmitting(true)
        if(checkIfWordCountIsZero()) return
        const repeated_words_count = repeatedWordsCount()
        post('/content_api/book.create_chapter?is_novel=1', {
          data: {
            book_id: id,
            chapter_id,
            word_count: wordCount,
            repeated_words_count,
            file_url: chapterDetails.result.file_url,
            chapter_title: title,
            status: chapterDetails.result.status,
            content_unchanged: 1,
            view: 'writers',
            program_type: novelDetails?.program_type || null
          },
        })
          .then(() => {
            handlePublishChapterWithVoice(chapter_id, chapterDetails.result.file_url, true)
            setAlertText('Updated Successfully')
            setSavedChanges(true)
            setIsSubmitting(false)
            setTitleChanged(false)
            props.history.goBack()
            setIsBack(true)
          })
          .catch((err) => {
            setIsSubmitting(false)
            if(novelDetails.content_editing && err.code === 400){
              setRestrictDelete(true)
            }else throw err
          })
      }
    }
  }

  const uploadFile = (status,userCalendarDate,editorContent) => {
    //create a text file

    const content = editorContent ?? getContent(editorState)

    const file = new Blob([content], {
      type: 'text/plain;charset=utf-8',
    })

    // upload to s3
    const params = {
      title,
      tags: 'file',
      file_dir: id,
      image_extension: 'txt',
    }

    get(`/upload/get_presigned_url`, {
      params: params,
    })
      .then((response) => {
        const imageUrl = response.result[0]
        const awsFields = imageUrl.fields
        const prefix = imageUrl.url
        const suffix = imageUrl.s3_unique_key
        const formData = new FormData()
        formData.append('key', awsFields.key)
        formData.append('AWSAccessKeyId', awsFields.AWSAccessKeyId)
        formData.append(
          'x-amz-security-token',
          awsFields['x-amz-security-token']
        )
        formData.append('policy', awsFields.policy)
        formData.append('signature', awsFields.signature)
        formData.append('file', file)
        const cdn = 'https://d31b0xt3oaqqjh.cloudfront.net'
        post(prefix, { data: formData })
          .then(() => {
            const url = `${cdn}/${id}/${suffix}`
            createChapterOrVersion(status, url,userCalendarDate)
            // setSavedChanges(true);
          })
          .catch((error) => {
            setIsSubmitting(false)
            throw error
          })
      })
      .catch((err) => {
        setIsSubmitting(false)
        throw err
      })
  }

  const updateWordCount = count => {
    setWordCount(count)
  }

  const handleTitleChange = title => {
    setTitle(title)
    setTitleChanged(true)
  }

  const onBack = () => {
      if(isBack){
        history.goBack()
      }
      else if(titleChanged && wordCount > 0 ){
        setWarningPopup(true)
        return
      }
      else if(!isContentChanged(editorState)){
        history.goBack()
      }else{
        setWarningPopup(true)
      }
  }
  const onChangeTimeClick=()=>{
    setSchedulePublishPopup(false);
    setCalendarPopup(true);
  }
  const onBackClick=()=>{
    setSchedulePublishPopup(true);
    setCalendarPopup(false);
  }
  const handlePopUpClose = () => {
    if(popUpLoader) return
    setDeclarationPopup(false);
    updateCdCheckbox({
      copyright_declaration: false,
      sexual_content_declaration: false,
      non_consensual_sex_declaration: false
    });
  }

  const conditionForSaveAndPublish = (action === 'add-chapter' || (action === 'edit-chapter' && chapterDetails && chapterDetails.result.status === 'draft'))

  const removeUnsavedChangesHandler = () => {
    setHasUnsavedChanges(false)
    const chapterObject = getChapterObject()
    if(chapterObject){
      chapterObject.content = content
      setChapterObject(chapterObject)
    }
  }

  const addUnsavedChangesHandler = () => {
    setHasUnsavedChanges(false)
    const chapterObject = getChapterObject()
    if(chapterObject) {
      setContent(chapterObject.content)
      if(conditionForSaveAndPublish){
        setIsSubmitting(true)
        setAlertText('Saved Successfully')
        uploadFile('draft',undefined,chapterObject.content)
      } 
    }
  }

  const handleAddChapter = () => {
    handleEventLog("post_publish", "button_click", {
      module_name: 'next_chapter_Write your next chapter',
      entity_id : showPostPublishData.chapter_id || '',
      entity_type : "chapter"
    })
    props.history.push(
      `${menuItemObj.novels}/add-chapter/${novelDetails?.book_id}?proceed_to_details=&count=${parseInt(novelDetails.stats.published_chapter_count + 1)}`
    ); 
    window.location.reload(); 
  }

  return (
    <Provider value={() => (
      !showPostPublishScreen  ? <EditorControls
        title={title}
        regex={/^Ch\s\d+\s-\s/}
        onBack={onBack}
        onTitleChange={handleTitleChange}
        chapterCount={chapterCount}
        action={action}
        tab={tab}
        wordCount={wordCount}
        isUgcBook={novelDetails?.is_novel === 2}
        undoActive={!isUndoEmpty(editorState)}
        redoActive={!isRedoEmpty(editorState)}
        handleUndo={() => onUndo(editorState, setEditorState)}
        handleRedo={() => onRedo(editorState, setEditorState)}
        handleShowRevision={() => toggleShowVersion(true)}
        showRevisionsIcon={chapter_id}
        actionButtons={{
          secondary: {
            label: 'Save',
            tooltip: title.length === 0
            ? 'Please type the title first'
            : wordCount === 0
            ? 'Please type the content'
            : '',
            icon: SaveIcon,
            show: conditionForSaveAndPublish,
            enabled: title.length > 0 && wordCount > 0 && !isSubmitting && (isContentChanged(editorState) || titleChanged),
            onClick: handleVersionSave
          },
          primary: {
            label: conditionForSaveAndPublish ? 'Publish' : chapterDetails ? 'Update' : 'Publish',
            tooltip: (chapterDetails && chapterDetails.result.status === 'published'?title.split('-')[1]?.length<2 :title.length === 0)
            ? 'Please type the title first'
            : wordCount < novelChapterWordCount
            ? `Please type at least ${novelChapterWordCount} words to continue`
            : wordCount > 5000
            ? 'Maximum 5000 words allowed'
            : '',
            icon: CircleCheck,
            show: true,
            enabled: (chapterDetails && chapterDetails.result.status === 'published'?title.split('-')[1]?.length>1 :title.length >0) && wordCount >= novelChapterWordCount && wordCount <= 5000 && !isSubmitting,
            onClick: conditionForSaveAndPublish ? () => toggleSchedulerPopup(true) : handleVersionUpdate
          }
        }}
      /> : <></>)
    }>
      <PrivatePage isProfileNameShown={false}>
        {!showPostPublishScreen ? <>
          <RestrictDelete 
            restrictDelete={restrictDelete}
            setRestrictDelete={setRestrictDelete}
          />
          <WarningPopup 
            warningPopup={warningPopup}
            setWarningPopup={setWarningPopup}
            removeUnsavedChangesHandler={removeUnsavedChangesHandler}
            history={history}
          />
          <DeclarationPopup 
            declarationPopUp={declarationPopUp}
            handlePopUpClose={handlePopUpClose}
            updateCdCheckbox={updateCdCheckbox}
            cdCheckbox={cdCheckbox}
            handleVersionPublishPopUp={handleVersionPublishPopUp}
            popUpLoader={popUpLoader}
          />
          {/* These components are not in use but waiting for QA testing also, then will remove these */}
          {/* <SchedulePublishPopup 
            schedulePublishPopup={schedulePublishPopup}
            setSchedulePublishPopup={setSchedulePublishPopup}
            title={title}
            wordCount={wordCount}
            timer={timer}
            toggleTimer={toggleTimer}
            onPublishButtonClick={onPublishButtonClick}
            userCalendarDate={userCalendarDate}
            onChangeTimeClick={onChangeTimeClick}
          /> */}
          {/* <CalendarPopup 
            calendarPopup={calendarPopup}
            setCalendarPopup={setCalendarPopup}
            setUserCalendarDate={setUserCalendarDate}
            setSchedulePublishPopup={setSchedulePublishPopup}
            onBackClick={onBackClick}
            // schedulerPopup={schedulerPopup}
          /> */}
          <HasUnsavedChanges 
            hasUnsavedChanges={hasUnsavedChanges}
            setHasUnsavedChanges={setHasUnsavedChanges}
            removeUnsavedChangesHandler={removeUnsavedChangesHandler} 
            addUnsavedChangesHandler={addUnsavedChangesHandler}
          />
          <VerifyForBadPublish 
            verifyForBadPublish={verifyForBadPublish} 
            setVerifyForBadPublish={setVerifyForBadPublish}  
          />
          {window.screen.width <= 600 && <EditorControls
            title={title}
            regex={/^Ch\s\d+\s-\s/}
            wordCount={wordCount}
            onTitleChange={handleTitleChange}
            showTitle={true}
            isUgcBook={novelDetails?.is_novel === 2}
          />}
          {isLoading && !apiError && <Loader />}
          <GenericError show={apiError} onClose={() => toggleApiError(false)} />
          {!isLoading && 
            <TextEditor
              content={content}
              editorState={editorState}
              updateState={updateState}
              updateWordCount={updateWordCount}
            />}
          {!isLoading && showVersion && (
            <Revisions
              open={showVersion}
              close={() => toggleShowVersion(false)}
              chapter_id={chapter_id}
              book_id={id}
              restoreSuccessCB={fetchChapterDetails}
              {...props}
            />
          )}
          {/* <Preview
            open={showPreview}
            close={() => toggleShowPreview(false)}
            title={title}
            content={content}
          /> */}
          {schedulerPopup && 
            <ChapterScheduler 
              toggleSchedulerPopup={toggleSchedulerPopup} 
              novelDetails={novelDetails} 
              chapterDetails={{title, wordCount}} 
              handleVersionPublish={handleVersionPublish}
              isSubmitting={isSubmitting}
              audioSelction={audioSelction}
              updateAudioSelection={updateAudioSelection}
            />}
          {!isLoading && alertText && (savedChanges || hasPublishWarning ) && 
            <AlertSnackBar 
              closeBtn={true} 
              text={alertText} 
              close={() => {
                if(savedChanges) setSavedChanges(false); 
                if(hasPublishWarning) setHasPublishWarning(false); 
              }} 
            />}
        </>
        : <PostPublishScreen
            bookId={novelDetails.book_id} 
            handleBack={handleBackForPostPublishScreen} 
            showPostPublishData={showPostPublishData} 
            publishDate={userCalendarDate} 
            onAddChapter={() => handleAddChapter()}
          />}
      </PrivatePage>
    </Provider>
  )
}